import Environment from '@config/environment';
import { datadogRum } from '@datadog/browser-rum-slim';
import { Price } from '@interfaces/models/price';
import React from 'react';
import styles from './affirm.module.scss';

interface AffirmProps {
  price?: Price;
}

const Affirm: React.FC<AffirmProps> = ({ price }) => {
  const PUBLIC_API_KEY: string = Environment.payment.affirmPublicApiKey;

  if (!PUBLIC_API_KEY) {
    datadogRum.addError('payment_instalment_affirm_public_key_missing');
    return null;
  }

  return (
    <iframe
      width={520}
      height={700}
      title="affirm"
      src={`https://www.affirm.com/apps/prequal/?public_api_key=${PUBLIC_API_KEY}&unit_price=${price.cents}&page_type=product&locale=en_US`}
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      className={styles.affirmIframe}
    ></iframe>
  );
};

export default Affirm;
